import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=780a9dc2&"
import script from "./Send.vue?vue&type=script&lang=ts&"
export * from "./Send.vue?vue&type=script&lang=ts&"
import style0 from "./Send.vue?vue&type=style&index=0&id=780a9dc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports